import { Button } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';

const ApprovedSucceed = () => {
    const navigate = useNavigate();
    const location = useLocation();


    return (
        <div
            style={{
                background: `url('/assets/header_background.svg')`,
                position: 'absolute',
                width: '100%',
                backgroundColor: '#f9fcff',
                backgroundRepeat: 'no-repeat',
                display: 'flex',
                flexDirection: 'column',
                height: 'calc(100vh - 80px)',

            }}
        >
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginTop: 100,
                }}
            >
                <img
                    src={'/assets/success.svg'}
                    alt={'icon'}
                    style={{ marginRight: '10px', width: '300px', height: '300px' }}
                />

                <div
                    style={{
                        fontSize: '24px',
                        fontWeight: 700,
                        lineHeight: '31.2px',
                        alignItems: 'center',
                        color: '#000000'
                    }}
                >
                    <p>The request has been sent</p>

                </div>
                <div style={{ fontSize: '14px', fontWeight: 400, color: '#000000' }}>
                    {location.state?.user?.first_name} {location.state?.user?.last_name} {location.state?.absence_type.find(item => item.value === location.state?.maxPriority).label} {location.state?.data?.start_date} {'-'} {location.state?.data?.end_date}
                </div>
                <Button
                    style={{
                        width: '274px',
                        height: '50px',
                        borderRadius: '20px',
                        backgroundColor: '#3076DD',
                        color: '#FFF',
                        marginTop: '40px',
                        fontSize: 16,
                        fontWeight: 700
                    }}
                    onClick={() => navigate('/leave_request')}
                >
                    <div>SUBMIT ANOTHER REQUEST</div>
                </Button>
                <Button
                    type={'link'}
                    onClick={() => {
                        navigate('/staff_leave_calendar');
                    }}
                    style={{ color: '#DD3030', marginTop: '10px' }}
                >
                    <img
                        src={'/icons/arrow_right.svg'}
                        alt={'icon'}
                        style={{ marginRight: '10px' }}
                    />
                    <span style={{ fontWeight: 500, fontSize: '14px', color: '#DD3030' }}>
                        Open the staff leave calendar
                    </span>
                </Button>
            </div>
            <img
                src={'/assets/baloon.svg'}
                alt={'icon'}
                style={{
                    pointerEvents: 'none',
                    position: 'absolute',
                    zIndex: '99',
                    right: 0,
                    bottom: 0,
                }}
            />
        </div>
    );
};

export default ApprovedSucceed;
